import { defineComponent as _defineComponent } from 'vue'
import { MetricReportingPeriodType } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportingPeriodType',
  props: {
    type: null
  },
  setup(__props: any) {



return { __sfc: true,MetricReportingPeriodType }
}

})